import ShareSvg from '../../../assets/share.svg?react';
import { IconProps } from '../../types/IconProps';

export function Share({ size = 20, ...props }: IconProps) {
  return <ShareSvg data-testid="share-icon" width={size} height={size} {...props} />;
}

export default Share;
